import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Widget } from "../../../components/widget";
import { BillingDTO } from "../../../store/billing/models/dto";
import { BillableApi } from "../../../store/billing/models/internal";
import { toDecimal } from "../../../utils/utils";

export const SingleUsage: FunctionComponent<{
  item: BillingDTO.Responses.GetSingleUsage.T;
}> = ({ item }) => {
  const { t } = useTranslation("common");
  const { apiCalledAt, creditCostIncVat, featureNames, id } = item;
  return (
    <>
      <Widget title={t("general", { context: "title" })}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            {t("purchase-id", { ns: "billing" })}
          </Grid>
          <Grid item xs={6}>
            {id}
          </Grid>
          <Grid item xs={6}>
            {t("credit", { count: 2, context: "title" })}
          </Grid>
          <Grid item xs={6}>
            {apiCalledAt.local().format("yyyy-MM-DD HH:mm")}
          </Grid>
          <Grid item xs={6}>
            {t("credit-cost", { ns: "billing" })}
          </Grid>
          <Grid item xs={6}>
            {toDecimal(creditCostIncVat)}
          </Grid>
          <Grid item xs={6}>
            {t("features-used", { ns: "billing" })}
          </Grid>
          <Grid item xs={6}>
            {featureNames.map((x) => BillableApi.enum[x]).join(", ")}
          </Grid>
        </Grid>
      </Widget>
    </>
  );
};
